import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

// A sticky bar for top-of-page actions and navigation
export default function StickyBar({ className, children, style }) {
  return (
    <div
      className={classNames(
        "sticky top-0 z-30 bg-white flex items-center overflow-x-auto",
        className,
      )}
      style={style}
    >
      {children}
    </div>
  );
}

StickyBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.object,
};
